import { ButtonBoxedPrimary, H4, P } from "@/lib/styles";
import { smallLabelTypographicStyle } from "@/lib/styles/helpers";
import styled from "styled-components";

export const OpenPositionCardContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 40px;

  ${({ theme }) => theme.mediaQueries.tablet} {
    flex-direction: row;
    justify-content: space-between;
    padding: 24px;
    gap: 53px; //?
  }
  ${({ theme }) => theme.mediaQueries.laptop} {
    gap: 57px;
  }

  border-top: 1px solid ${({ theme }) => theme.colors.middleGrey};
  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.middleGrey};
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${({ theme }) => theme.mediaQueries.tablet} {
    max-width: 950px; // ?
  }
`;

export const Country = styled.p`
  ${smallLabelTypographicStyle}
  color: ${({ theme }) => theme.colors.red};
`;

export const Title = styled(H4)``;
export const Description = styled(P)``;

export const LinkContainer = styled.div`
  align-self: flex-end;
`;

export const ButtonStyled = styled(ButtonBoxedPrimary)`
  white-space: nowrap;
`;
